<div class="card-container">
  <div class="top-card">
    <span>{{cardHeaderLabel}}</span>
    <p [attr.percentage]="percentage>=0 ? 'up' : 'down'">
      {{cardHeaderCount | numberFormat : false}}
      <span>
        {{Math.abs(percentage) | numberFormat}}%
        <mat-icon>{{percentage >= 0 ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
      </span>
    </p>
  </div>

  <div class="genders-container">
    <div class="genders-statistics">
      <div class="gender-item males">
        <span class="point"></span>
        <p>
          <span>{{"GENDER.MALE" | translate}}</span>
          <span>{{totalMales | numberFormat : false}}</span>
        </p>
      </div>
      <div class="gender-item females">
        <span class="point"></span>
        <p>
          <span>{{"GENDER.FEMALE" | translate}}</span>
          <span>{{totalFemales | numberFormat : false}}</span>
        </p>
      </div>
    </div>

    <div class="progress">
      <span [style.width]="(totalMales/total * 100)+'%'"></span>
      <span [style.width]="(totalFemales/total * 100)+'%'"></span>
    </div>
  </div>
</div>
